import { render, staticRenderFns } from "./Event_Modal_Component.vue?vue&type=template&id=2a2a45a1&scoped=true"
import script from "./Event_Modal_Component.vue?vue&type=script&lang=js"
export * from "./Event_Modal_Component.vue?vue&type=script&lang=js"
import style0 from "./Event_Modal_Component.vue?vue&type=style&index=0&id=2a2a45a1&prod&scoped=true&lang=css"
import style1 from "./Event_Modal_Component.vue?vue&type=style&index=1&id=2a2a45a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a45a1",
  null
  
)

export default component.exports